import axios from 'axios';

// URL du serveur RDFox pour connexion directe
const RDFOX_DIRECT_URL = 'http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110';

// Connexion directe uniquement - proxy désactivé

// Informations d'authentification pour RDFox
const RDFOX_AUTH = {
  username: 'admin',
  password: 'grM3bgZiQkq9YQc'
};

// Type de connexion (directe uniquement)
export type ConnectionType = 'direct';

// Obtenir l'URL du serveur RDFox
export const getRDFoxURL = () => {
  return RDFOX_DIRECT_URL;
};

// Fonction pour vérifier si le serveur RDFox est disponible
export const checkRDFoxStatus = async (): Promise<boolean> => {
  try {
    const url = getRDFoxURL();
    const response = await axios.get(`${url}/datastores`, {
      timeout: 5000, // 5 seconds timeout
      auth: RDFOX_AUTH
    });
    return response.status === 200;
  } catch (error) {
    console.error(`Error checking RDFox status:`, error);
    return false;
  }
};

// Fonction pour obtenir l'URL du serveur RDFox
export const getRDFoxEndpoint = () => getRDFoxURL();

// Fonction pour obtenir les informations d'authentification
export const getRDFoxAuth = () => RDFOX_AUTH;

// Fonction pour parser les données TSV
export const parseTSV = (tsvData: string) => {
  if (!tsvData || tsvData.trim() === '') {
    return { head: { vars: [] }, results: { bindings: [] } };
  }
  
  const lines = tsvData.trim().split('\n');
  if (lines.length === 0) {
    return { head: { vars: [] }, results: { bindings: [] } };
  }
  
  // La première ligne contient les noms des variables
  const vars = lines[0].split('\t');
  
  // Les lignes suivantes contiennent les valeurs
  const bindings = [];
  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split('\t');
    const binding: Record<string, { type: string; value: string }> = {};
    
    for (let j = 0; j < vars.length; j++) {
      if (j < values.length) {
        binding[vars[j]] = { type: 'literal', value: values[j] };
      }
    }
    
    bindings.push(binding);
  }
  
  return {
    head: { vars },
    results: { bindings }
  };
};

// Fonction pour lister les datastores
export const listDatastores = async () => {
  try {
    const url = getRDFoxURL();
    console.log(`Listing datastores`);
    
    const endpoint = `${url}/datastores`;
    console.log(`Sending request to: ${endpoint}`);
    
    const response = await axios.get(endpoint, {
      headers: {
        'Accept': 'text/tab-separated-values'
      },
      timeout: 10000, // 10 seconds timeout
      auth: RDFOX_AUTH
    });
    
    console.log(`Datastores response:`, {
      status: response.status,
      contentType: response.headers['content-type'],
      dataLength: response.data ? response.data.length : 0
    });
    
    if (response.status === 200) {
      const tsvData = response.data;
      console.log(`Données TSV reçues:`, tsvData.substring(0, 200) + (tsvData.length > 200 ? '...' : ''));
      const parsed = parseTSV(tsvData);
      console.log(`Données TSV parsées:`, parsed);
      return parsed;
    }
    
    throw new Error(`Erreur lors de la récupération des datastores: ${response.status}`);
  } catch (error: any) {
    console.error(`Erreur lors de la liste des datastores:`, {
      message: error.message,
      code: error.code,
      response: error.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        headers: error.response.headers,
        data: error.response.data
      } : 'Pas de réponse'
    });
    // Retourner un objet vide au lieu de propager l'erreur
    return { head: { vars: [] }, results: { bindings: [] } };
  }
};

// Fonction pour obtenir les informations du serveur
export const getServerInfo = async () => {
  try {
    const url = getRDFoxURL();
    console.log(`Getting server information`);
    
    const endpoint = url;
    console.log(`Sending request to: ${endpoint}`);
    
    const response = await axios.get(endpoint, {
      headers: {
        'Accept': 'text/tab-separated-values'
      },
      timeout: 10000, // 10 seconds timeout
      auth: RDFOX_AUTH
    });
    
    console.log(`Server info response:`, {
      status: response.status,
      contentType: response.headers['content-type'],
      dataLength: response.data ? response.data.length : 0
    });
    
    if (response.status === 200) {
      const tsvData = response.data;
      console.log(`Données TSV reçues:`, tsvData.substring(0, 200) + (tsvData.length > 200 ? '...' : ''));
      const parsed = parseTSV(tsvData);
      console.log(`Données TSV parsées:`, parsed);
      return parsed;
    }
    
    throw new Error(`Erreur lors de la récupération des informations du serveur: ${response.status}`);
  } catch (error: any) {
    console.error(`Erreur lors de la récupération des informations du serveur:`, {
      message: error.message,
      code: error.code,
      response: error.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        headers: error.response.headers,
        data: error.response.data
      } : 'Pas de réponse'
    });
    // Retourner un objet vide au lieu de propager l'erreur
    return { head: { vars: [] }, results: { bindings: [] } };
  }
};

// Fonction pour tester la connexion au serveur
export const testConnection = async () => {
  try {
    const url = getRDFoxURL();
    console.log(`Testing connection to RDFox`);
    
    const endpoint = url;
    console.log(`Sending request to: ${endpoint}`);
    
    const response = await axios.get(endpoint, {
      headers: {
        'Accept': 'text/tab-separated-values'
      },
      timeout: 10000, // 10 seconds timeout
      auth: RDFOX_AUTH
    });
    
    console.log(`Connection successful to RDFox - Status: ${response.status}`);
    return response.status === 200;
  } catch (error: any) {
    console.error(`Erreur lors du test de connexion:`, {
      message: error.message,
      code: error.code,
      response: error.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        headers: error.response.headers,
        data: error.response.data
      } : 'Pas de réponse'
    });
    return false;
  }
};

// Fonction pour vérifier la disponibilité du serveur
export const checkServerAvailability = async () => {
  try {
    console.log(`Checking RDFox server availability`);
    const isAvailable = await testConnection();
    
    if (isAvailable) {
      console.log(`RDFox server available, retrieving datastores`);
      try {
        const datastores = await listDatastores();
        console.log(`Datastores retrieved:`, datastores);
        
        if (datastores && datastores.results && datastores.results.bindings) {
          const datastoreList = datastores.results.bindings.map(b => b.datastore?.value || '');
          console.log(`Datastore list:`, datastoreList);
          return {
            available: true,
            datastores: datastoreList
          };
        } else {
          console.warn(`Invalid datastore response format:`, datastores);
          return { available: true, datastores: [] };
        }
      } catch (listError: any) {
        console.error(`Error retrieving datastores:`, listError.message);
        // Server is available but there was an error retrieving datastores
        return { available: true, datastores: [] };
      }
    }
    
    console.log(`RDFox server not available`);
    return { available: false, datastores: [] };
  } catch (error: any) {
    console.error(`Error checking server availability:`, error.message);
    return { available: false, datastores: [] };
  }
};

// Fonction pour obtenir les statistiques d'un datastore
export const getDatastoreStats = async (datastore: string) => {
  try {
    const url = getRDFoxURL();
    const response = await axios.get(`${url}/datastores/${datastore}/stats`, {
      auth: RDFOX_AUTH,
      headers: {
        'Accept': 'text/tab-separated-values'
      }
    });
    
    if (response.status === 200) {
      const tsvData = response.data;
      return parseTSV(tsvData);
    }
    
    throw new Error(`Erreur lors de la récupération des statistiques du datastore: ${response.status}`);
  } catch (error) {
    console.error(`Erreur lors de la récupération des statistiques du datastore:`, error);
    throw error;
  }
};
